<template>
  <div v-if="onlyContent" class="wrap">
    <main id="t-content" class="t-layout__content only-content">
      <content-vue :user-info="userInfo"></content-vue>
      <footer v-if="!hideFooter" class="footer"><footer-vue /></footer>
    </main>
  </div>
  <div v-else class="wrap">
    <div class="content">
      <header class="header"><header-vue :user-info="userInfo"></header-vue></header>
      <main id="t-content" class="t-layout__content">
        <div class="content-vue"><content-vue :user-info="userInfo"></content-vue></div>
        <footer v-if="!hideFooter" class="footer"><footer-vue /></footer>
      </main>
    </div>
  </div>
</template>
<script setup lang="tsx">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store';
import headerVue from './Header.vue';
import contentVue from './Content.vue';
import footerVue from './Footer.vue';
import { QueryType } from '@tencent/iegsp-common/tools/utils/util';

const { userInfo } = storeToRefs(useUserStore());

const route = useRoute();
const onlyContent = computed(() => !!(route?.query?.[QueryType.Outside] || route?.meta?.hideLayout));
const hideFooter = computed(() => route?.meta?.hideLayoutFooter);
</script>
<style lang="less" scoped>
.wrap {
  height: 100%;
  width: 100%;
  color: #ffffff;

  .only-content {
    width: 100%;
    height: 100%;
  }

  .content {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f3f3f3;

    .t-layout__content {
      flex: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }

    .content-vue {
      width: 100%;
      flex: 1;
    }
  }

  .footer {
    padding: 24px 0;
  }
}
</style>
